<template>
    <div class="header">
        <div class="tabs">
            <div class='tab' :class="index == activeIndex ? 'active' : ''" v-for="(item, index) in  tabs" :key='index'
                @click="onclick(item, index)">{{ item.name }}</div>
        </div>
        <h1 class="title">通辽市肉牛产业数据中心</h1>
        <div class="info">
            <span class="time">
                {{ current }}
            </span>
            <span class="date">
                {{ time }}
            </span>
        </div>
    </div>
</template>

<script>

export default {
    components: {
        // Main,
    },
    data() {
        return {
            activeIndex: 2,
            tabs: [
                {
                    name: '产业资源',
                    path: 'https://rpt.gtc315.cn/tongliao/index?c=cyzy'
                },
                {
                    name: '养殖加工',
                    path: 'https://rpt.gtc315.cn/tongliao/index?c=yzjg'
                },
                {
                    name: '流通营销',
                    path: 'https://rpt.gtc315.cn/tongliao/index?c=ltyx'
                },
                {
                    name: '产业监管',
                    path: 'https://rpt.gtc315.cn/tongliao/index?c=cyjg'
                },
                {
                    name: '产业服务',
                    path: 'https://rpt.gtc315.cn/tongliao/index?c=cyff'
                },
            ],
            time: null,
            current: null,
            week: null,
            timer: null//定时器
        };
    },
    created() {

    },
    // 销毁定时器
    destroyed() {
        clearInterval(this.timer)
    },
    mounted() {
        this.getTime()
    },
    methods: {
        getTime() {
            // var year = new Date().getYear();//获取当前年份（2位）
            // var fullYear = new Date().getFullYear();//获取当前完整年分（4位）
            // var month = new Date().getMonth();//获取当前月份（0~11，0代表1月）
            // var day = new Date().getDate();//获取当前日（1-31日）
            // var h = new Date().getHours();//获取当前小时（0~23）
            // var m = new Date().getMinutes();//获取当前分钟数（0~59）
            // var s = new Date().getSeconds();//获取当前秒数（0~59）
            // var ss = new Date().getMilliSeconds();//获取当前毫秒数（0-999）
            // var currentTime = new Date().toLocaleString(); //获取日期与时间
            this.current = new Date().toLocaleDateString().replace(/\//g, '年');//获取当前日期（“年/月/日”）
            var arr = []
            arr = this.current.split('')
            arr.push('*')
            arr.forEach((item, i) => {
                if (i != 4 && item == '年') {
                    arr[i] = '月'
                }
                if (item == '*') {
                    arr[i] = '日'
                }
            })
            this.current = arr.join('')
            this.week = new Date().getDay();//获取当前星期（0~6，0代表星期天）
            if (this.timer) {
                clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
                var time = new Date().toLocaleTimeString();//获取当前时间
                this.time = time
            }, 1000)
        },
        onclick(item, index) {
            // if(this.$route.path==item.path){
            // 	return
            // }
            this.activeIndex = index
            if (this.activeIndex == '2') {
                return
            }
            location.href = item.path
            // console.log(item,index)
            // this.$router.push({
            //     path:item.path
            // })
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    background: url(~@/assets/tl/head-bj.png);
    display: flex;
    width: 100%;
    height: 1.03rem;
    justify-content: space-between;
    padding: 0 0.25rem;
    align-items: center;
    position: relative;

    z-index: 999;
    // position: absolute;
    top: 0;
    left: 0;

    // width: 24rem;
    // height: 1.01rem;
    .tabs {
        display: flex;
        align-items: center;

        .tab {
            cursor: pointer;
            font-size: 0.23rem;
            font-family: Source Han Sans CN-Normal, Source Han Sans CN;
            font-weight: 350;
            color: #00E0DB;
            text-align: center;
            margin-right: 0.18rem;
            width: 1.96rem;
            height: 0.53rem;
            line-height: 0.53rem;
            background: url(~@/assets/tl/active.png);
            background-position: center;
        }

        .tab:nth-child(1) {
            position: absolute;
            top: 0.36rem;
            left: 1.25rem;
        }

        .tab:nth-child(2) {
            position: absolute;
            top: 0.48rem;
            left: 2.94rem;
        }

        .tab:nth-child(3) {
            position: absolute;
            top: 0.63rem;
            left: 4.68rem;
        }

        .tab:nth-child(4) {
            position: absolute;
            top: 0.63rem;
            right: 4.68rem;
        }

        .tab:nth-child(5) {
            position: absolute;
            top: 0.48rem;
            right: 2.94rem;
        }

        .active {

            background: url(~@/assets/tl/active-bg.png);
            background-position: center;
        }
    }

    .title {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.5rem;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        font-weight: 700;
        color: #c2ecea;
        line-height: 0.6rem;
        letter-spacing: 3px;

        // text-shadow: 0px 0px 0px rgba(0, 0, 0, 0.302);
        &::after {
            content: '';
            background: url(~@/assets/tl/header-left.png)no-repeat center center;
            background-size: 100% 100%;
            width: .38rem;
            height: .38rem;
            position: absolute;
            top: 0.16rem;
            left: -0.8rem;
            animation: rotateAgin2 2s ease-in-out infinite alternate;
            // transform: rotateY(180deg);
        }

        &::before {
            content: '';
            background: url(~@/assets/tl/header-right.png)no-repeat center center;
            background-size: 100% 100%;
            width: .38rem;
            height: .38rem;
            position: absolute;
            top: 0.16rem;
            right: -0.8rem;
            animation: rotateAgin 2s ease-in-out infinite alternate;
        }
    }

    @keyframes rotateAgin2 {
        0% {

            transition: all;
            opacity: 0.5;
        }
        50% {

transition: all;
opacity: 0.1;

}
        100% {

            transition: all;
            opacity: 1;
        }
    }

    @keyframes rotateAgin {
        0% {

            transition: all;
            opacity: 0.5;

        }

        50% {

            transition: all;
            opacity: 0.1;

        }

        100% {

            transition: all;
            opacity: 1;
        }
    }

    .info {
        display: flex;
        align-items: center;
        margin-top: -0.35rem;

        .time {
            font-size: 0.23rem;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            margin-right: 0.2rem;
        }

        .date {
            font-size: 0.23rem;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            // margin-right: 0.18rem;
        }
    }
}</style>